import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faGlobe, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useMap } from 'react-leaflet';
import { useEffect } from 'react';

const LoginRegister = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
const [hoveredLocation, setHoveredLocation] = useState({
  type: "bounds", // أو "point"
  coords: null,
});



const MiniMap = ({ position }) => (
  <div style={{ width: 200, height: 120, marginLeft: 10 }}>
    <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ width: '100%', height: '100%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position} icon={L.icon({ iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png", iconSize: [25, 41], iconAnchor: [12, 41] })} />
    </MapContainer>
  </div>
);

const MapUpdater = ({ hoveredLocation }) => {
  const map = useMap();

  useEffect(() => {
    if (!hoveredLocation || !hoveredLocation.coords) return;

    if (hoveredLocation.type === "bounds") {
      const bounds = L.latLngBounds(hoveredLocation.coords);
      map.fitBounds(bounds);
    } else if (hoveredLocation.type === "point") {
      map.setView(hoveredLocation.coords, 13);
    }
  }, [hoveredLocation, map]);

  return null;
};




const mapIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});


  return (
    <div style={styles.page}>
      {/* ✅ Header */}
      <div style={styles.header}>
        <div style={styles.logoSection}>
          <img src="/Asset 18.png" alt="EarthScan Logo" style={styles.logoImage} />
        </div>
        <div style={styles.navSection}>
          <a href="/" style={styles.navLink}>Home</a>
            <a href="/about" style={styles.navLink}>About Us</a>
            <a href="/contact" style={styles.navLink}>Contact Us</a>

        </div>
      </div>

      <div style={styles.container}>
        {/* Left Panel */}
        <div style={styles.leftPanel}>
          <h2 style={styles.welcomeTitle}>Welcome{isRegister ? '!' : ' back!'}</h2>
          <p style={styles.welcomeText}>
            {isRegister
              ? "Start your journey in the vast lands of Sobek"
              : "We’re very glad to see you back. Continue your journey in the vast lands of"}
            &nbsp;
            <a href="https://sobekglobal.com" target="_blank" rel="noopener noreferrer" style={{ color: '#C18429', fontWeight: 'bold', textDecoration: 'none' }}>
              SOBEK
            </a>
          </p>

          <div style={styles.noteBox}>
            <strong>Note:</strong> The Account you create here is automatically synced with our Digital Platform.
          </div>

          <div style={styles.logoRow}>
            <a href="https://sobekglobal.com" target="_blank" rel="noopener noreferrer">
              <img src="/Asset 2.png" alt="Sobek" style={styles.logo} />
            </a>
            <a href="https://dronepilott.com" target="_blank" rel="noopener noreferrer">
              <img src="/Asset 1.png" alt="Drone Pilot" style={styles.logo} />
            </a>
          </div>
        </div>
{/* Right Panel */}
        <div style={styles.rightPanel}>
          <form style={styles.form}>
            {showResetPassword ? (
              <>
                <h2 style={{ color: '#ddd', marginBottom: '15px', fontSize: '28px' }}>Reset Password</h2>
                <p style={{ color: '#ccc', fontSize: '16px', lineHeight: '1.6' }}>
                  If you’ve forgotten your password, kindly reset it by following the instructions.
                  <strong style={{ display: 'block', marginTop: '10px', color: '#ddd' }}>
                    Note: This will change the password for both sites.
                  </strong>
                </p>
                <p style={{ color: '#999', fontSize: '16px', marginBottom: '10px' }}>
                  To reset your password, please enter your email address or username below.
                </p>
                <input
                  type="text"
                  placeholder="Enter your username or email"
                  style={styles.input}
                />
                <button type="submit" style={{ ...styles.loginBtn, backgroundColor: '#30a9de' }}>Reset password</button>
                <a href="#" onClick={(e) => { e.preventDefault(); setShowResetPassword(false); }} style={styles.forgotPassword}>Back to Login</a>
              </>
            ) : isRegister ? (
              <>
                <label style={styles.label}>Username</label>
                <input type="text" style={styles.input} />
                <label style={styles.label}>Name</label>
                <input type="text" style={styles.input} />
                <label style={styles.label}>E-mail Address</label>
                <input type="email" style={styles.input} />
                <label style={styles.label}>WhatsApp number</label>
                <input type="text" style={styles.input} />
                <label style={styles.label}>Password</label>
                <input type="password" style={styles.input} />
                <label style={styles.label}>Confirm Password</label>
                <input type="password" style={styles.input} />
                <button type="submit" style={styles.registerBtn}>Register</button>
              </>
            ) : (
              <>
                <label style={styles.label}>Username or E-mail</label>
                <input type="text" style={styles.input} />
                <label style={styles.label}>Password</label>
                <input type="password" style={styles.input} />
                <div style={styles.checkboxRow}>
                  <input type="checkbox" id="keepSignedIn" />
                  <label htmlFor="keepSignedIn" style={styles.checkboxLabel}>Keep me signed in</label>
                </div>
                <button type="submit" style={styles.loginBtn}>Login</button>
                <a href="#" onClick={(e) => { e.preventDefault(); setShowResetPassword(true); }} style={styles.forgotPassword}>Forgot your password?</a>
              </>
            )}

            <div style={styles.buttonRow}>
              <button type="button" style={{ ...styles.loginBtn, backgroundColor: !isRegister ? "#30a9de" : "#444" }} onClick={() => { setIsRegister(false); setShowResetPassword(false); }}>Login</button>
              <button type="button" style={{ ...styles.registerBtn, backgroundColor: isRegister ? "#e6e6e6" : "#777" }} onClick={() => { setIsRegister(true); setShowResetPassword(false); }}>Register</button>
            </div>
          </form>
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
<div style={{ ...styles.footerColumn, paddingLeft: '20px' }}>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
  <img src="/Asset 18.png" alt="Sobek Logo" style={{ height: 100 }} />
</div>
          <p style={{ ...styles.footerText }}>
EarthScan® is a powerful digital geospatial platform that provides accurate, up-to-date satellite imagery, advanced analytics and geospatial intelligence. Designed to support professionals, researchers, and organizations across industries with reliable, accurate, and up-to-date geospatial data to drive smarter decisions through easy access to metadata, spatial tools, and insightful visualizations.</p>

          <div style={styles.socials}>
            <a href="#"><i className="fa fa-facebook" /></a>
            <a href="#"><i className="fa fa-instagram" /></a>
            <a href="#"><i className="fa fa-twitter" /></a>
          </div>
        </div>

<div style={{ ...styles.footerColumn, paddingLeft: '30px', marginLeft: '-100px',marginTop : '18px' }}>
          <h4 style={styles.footerTitle}>Quick Links</h4>
          <p>Home</p>
          <p>About Us</p>
          <p>Contact Us</p>
          
        </div>
 <div style={{ ...styles.footerColumn }}>
  <h4 style={{
    color: '#C18429',
    fontSize: '18px',
    marginBottom: '20px',
    textAlign: 'left' // ✅ خليه زي باقي النص
  }}>
    Get In Touch
  </h4>
<div
  style={styles.footerLine}
onMouseEnter={() =>
  setHoveredLocation({
    type: "bounds",
    coords: [
      [22.0, 25.0],  // جنوب غرب مصر
      [31.5, 36.5],  // شمال شرق مصر
    ],
        marker: [30.0444, 31.2357], // موقع القاهرة

  })
}
>
  <FontAwesomeIcon icon={faMapMarkerAlt} style={styles.footerIcon} />
  <span>Headquarter - New Capital, Egypt.</span>
</div>

<div
  style={styles.footerLine}
onMouseEnter={() =>
  setHoveredLocation({
    type: "bounds",
    coords: [
      [16.0, 34.0],  // جنوب غرب السعودية
      [32.0, 56.0],  // شمال شرق السعودية
    ],
        marker: [24.7136, 46.6753], // موقع الرياض

  })
}
>
  <FontAwesomeIcon icon={faMapMarkerAlt} style={styles.footerIcon} />
  <span>Branch - Riyadh, Saudi Arabia.</span>
</div>



  <div style={styles.footerLine}>
    <FontAwesomeIcon icon={faPhone} style={styles.footerIcon} />
    <span>+20 102 143 5596</span>
  </div>

  <div style={styles.footerLine}>
    <FontAwesomeIcon icon={faPhone} style={styles.footerIcon} />
    <span>+966 57 842 8969</span>
  </div>

  <div style={styles.footerLine}>
    <FontAwesomeIcon icon={faGlobe} style={styles.footerIcon} />
    <a href="https://sobekglobal.com" target="_blank" rel="noopener noreferrer" style={styles.footerLink}>
      www.sobekglobal.com
    </a>
  </div>

  <div style={styles.footerLine}>
    <FontAwesomeIcon icon={faEnvelope} style={styles.footerIcon} />
    <a href="mailto:Info@sobekglobal.com" style={styles.footerLink}>
      Info@sobekglobal.com
    </a>
  </div>

  <div style={styles.footerLine}>
    <FontAwesomeIcon icon={faEnvelope} style={styles.footerIcon} />
    <a href="mailto:earthscan@sobekglobal.com" style={styles.footerLink}>
      earthscan@sobekglobal.com
    </a>
  </div>

 



</div>

 <div style={{ marginTop: "0px" }}>
    <h4 style={{ color: "#1ba99e", fontSize: "18px", marginBottom: "20px",marginTop: "30px" }}>
      Location Preview
    </h4>
    <div style={{
      width: '300px',
      height: '200px',
      maxWidth: '500px',

      borderRadius: '10px',
      overflow: 'hidden',
      border: '1px solid #333'
    }}>
     <MapContainer
  center={hoveredLocation?.marker || [26.5, 44]} // fallback
  zoom={5}
  scrollWheelZoom={false}
  style={{ width: '100%', height: '100%' }}
>
  <TileLayer
    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
    attribution="Esri, DeLorme, NAVTEQ"
  />
  <MapUpdater hoveredLocation={hoveredLocation} />
  
  {/* ✅ Show marker if present */}
  {hoveredLocation?.marker && (
    <Marker position={hoveredLocation.marker} icon={mapIcon} />
  )}
</MapContainer>

    </div>
  </div>



      </footer>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: '#111',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
    color: '#fff',
    padding: '0', // ❌ شيلنا الفراغ اللي كان من فوق
  margin: '0',
  },
  container: {
    display: 'flex',
    width: '80%',
    maxWidth: '1000px',
    margin: 'auto',
    backgroundColor: '#1a1a1a',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 0 20px rgba(0,0,0,0.4)',
    marginBottom: '60px',
  },
  leftPanel: {
    flex: 1,
    padding: '60px 40px',
  },
  rightPanel: {
    flex: 1,
    padding: '60px 40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#1a1a1a',
  },
  welcomeTitle: {
    fontSize: '28px',
    marginBottom: '15px',
    fontWeight: 'bold',
  },
  welcomeText: {
    fontSize: '17px',
    color: '#ccc',
    lineHeight: '1.6',
    marginBottom: '20px',
  },
  noteBox: {
    backgroundColor: '#d8f9d1',
    padding: '10px',
    borderRadius: '5px',
    color: '#111',
    fontSize: '14px',
    marginBottom: '20px',
  },
  link: {
    color: '#30a9de',
    textDecoration: 'underline',
  },
  logoRow: {
    display: 'flex',
    gap: '30px',
    marginTop: '30px',
     height: '80px',
  },
  logo: {
    height: '70px',
    objectFit: 'contain',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginTop: '15px',
    marginBottom: '5px',
    fontSize: '14px',
    color: '#ccc',
  },
  input: {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: '10px',
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
  },
  checkboxLabel: {
    marginLeft: '8px',
    fontSize: '14px',
    color: '#ccc',
  },
  buttonRow: {
    display: 'flex',
    gap: '10px',
    marginTop: '15px',
  },
  loginBtn: {
    flex: 1,
    backgroundColor: '#30a9de',
    color: '#fff',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  registerBtn: {
    flex: 1,
    backgroundColor: '#e6e6e6',
    color: '#000',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  forgotPassword: {
    marginTop: '15px',
    color: '#ccc',
    fontSize: '13px',
    textDecoration: 'underline',
    textAlign: 'right',
    display: 'block',
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    borderTop: "1px solid #333",
    padding: "40px 60px",
    backgroundColor: "#0d0d0d",
  },
 footerColumn: {
  flex: "1",
  minWidth: "280px",
  maxWidth: "500px", // العرض المثالي
  marginBottom: "30px",
fontSize: "14px",
  lineHeight: "1.5",
  color: "#ccc",
  marginTop: "5px",
  textJustify: "inter-word",
  hyphens: "auto",
  wordBreak: "break-word",


  },
  footerTitle: {
    color: "#1ba99e",
    fontSize: "18px",
    marginBottom: "10px",
    
  },
  footerText: {
  fontSize: "14px",
  lineHeight: "1.5",
  color: "#ccc",
  marginTop: "5px",
  textAlign: "justify",
  textJustify: "inter-word",
  hyphens: "auto",
  wordBreak: "break-word",
},



  

  footerLine: {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '12px', // ⬅️ زيادة المسافة بين السطور
  fontSize: "14px",
  lineHeight: "1.5",
  color: "#ccc",
  marginTop: "5px",
  textAlign: "justify",
  textJustify: "inter-word",
  hyphens: "auto",
  wordBreak: "break-word",
},

footerIcon: {
  color: '#C18429',
  width: 20,
  minWidth: 20,
  marginRight: 10,
},

footerLink: {
  color: '#fff',
  textDecoration: 'none',
},

  socials: {
    display: "flex",
    gap: "15px",
    marginTop: "10px",
    fontSize: "20px",
  },
  header: {
    backgroundColor: "#0b0b0b",
    padding: "10px 40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 1px 5px rgba(0,0,0,0.3)",
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
  },
  logoImage: {
    height: "85px",
  },
  navSection: {
    display: "flex",
    gap: "20px",
  },
  navLink: {
    color: "#ffffff",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "bold",
  },
};

export default LoginRegister;
